// extracted by mini-css-extract-plugin
export default {"melodyVideo":"MM-z","isFullWidth":"NM-z","landingPageVideo":"OM-z","play":"PM-z","iframeVideo":"QM-z","playHidden":"RM-z","fullwidth":"SM-z"};